export const contentfulContentTypes = {
  rodPicturesHarvest: 'rodPicturesHarvest',
  rodPicturesFlowers: 'rodPicturesFlowers',
  rodStatute: 'rodStatute',
  rodPdf: 'rodPdf',
  rodInfo: 'rodInfo',
  rodArticles: 'rodArticles',
  rodFees: 'rodFees',
};
